import { Helmet } from "react-helmet-async";

interface Props {
  title: string;
  description: string;
  path?: string;
}

const SITE = "https://www.mineoptics.com";

export function Seo({ title, description, path }: Props) {
  const fullTitle = title.includes("MineOptics") ? title : `${title} | MineOptics`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {path !== undefined && <link rel="canonical" href={`${SITE}${path}`} />}
    </Helmet>
  );
}
